import { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import styledComponents from "styled-components";

import {
  Box,
  Divider,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Grid,
  Typography,
  TextField,
  Button,
  Menu,
  MenuItem,
  ListItemIcon,
  Modal,
  InputLabel,
  IconButton,
  Tabs,
  Tab,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Select,
  Stack,
  Paper
} from "@mui/material";

import axios from  "axios";
import { Formik } from 'formik';
import AddCircleIcon from '@mui/icons-material/AddCircle';
import DeleteIcon from '@mui/icons-material/Delete';

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ p: 3 }}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    'aria-controls': `simple-tabpanel-${index}`,
  };
}

function createData(name, calories, fat, carbs, protein) {
  return { name, calories, fat, carbs, protein };
}

const modalStyle = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: { xs: '80%', md: 400 },
  maxHeight: '66vh',
  bgcolor: 'background.paper',
  boxShadow: 24,
  p: 4,
  overflow: 'scroll'
};

const Container = styledComponents.div`
    padding: 20px;
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
`;

const Saldo = () => {    
    const [saldoData, setSaldoData] = useState([]);

    useEffect(() => {
      const getSaldo = async () => {
        try {
          const saldo = await axios.get(`${process.env.REACT_APP_API_URL}/api/dashboard/saldo`, {
            headers: {
              Authorization: `Bearer ${JSON.parse(localStorage.getItem('token')).token}`
            }
          });
          let number = 0;
          setSaldoData(saldo.data.result.map((v) => {
            number+=1;
            return { ...v, no: number };
          }));
        } catch (err) {
          console.log(err);
        }
      };
      getSaldo();
    }, [])

    return (
      <Container>
        <TableContainer component={Paper} sx={{ maxHeight: {xs: '70vh', sm: 740, md: 800} }}>
          <Table stickyHeader aria-label="sticky table" sx={{ minWidth: 650 }}>
            <TableHead>
              <TableRow>
                <TableCell>No</TableCell>
                <TableCell align="left">Tanggal</TableCell>
                <TableCell align="left">Transaksi</TableCell>
                <TableCell align="left">Debit</TableCell>
                <TableCell align="left">Kredit</TableCell>
                {/* <TableCell align="left">Aksi</TableCell> */}
              </TableRow>
            </TableHead>
            <TableBody>
              {saldoData.map((row) => (
                <TableRow
                  key={row.id_saldo}
                  sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                >
                  <TableCell align="left">{row.no}</TableCell>
                  <TableCell align="right">{row.tgl}</TableCell>
                  <TableCell
                    align="left"
                    sx={{
                      maxWidth: {xs: '180px', sm: '340', md: '500px'}
                    }}
                  >
                    {row.transaksi}
                  </TableCell>
                  <TableCell align="right">{row.debit}</TableCell>
                  <TableCell align="right">{row.credit}</TableCell>
                  {/* <TableCell align="left">
                    <Button><DeleteIcon onClick={() => handleDeleteDialog(row.idmitraagen, 'agen')} /></Button>
                  </TableCell> */}
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      </Container>
    )
}

export default Saldo;
